const videoOverlay = {
  el: {
    embedFrame: document.querySelectorAll<HTMLElement>('.article-video-block__video-embed'),
  },

  init(): void {
    Array.prototype.forEach.call(this.el.embedFrame, (item) => {
      const videoUrl = item.dataset.videoUrl
      const autoplay = item.dataset.autoplay

      // if not internal, then convert video link to appropriate format
      if (videoUrl !== '') {
        const youtubeRegex = /(http:|https:)?\/\/(www\.)?(youtube.com|youtu.be)\/(watch)?(\?v=)?(\S+)?/
        const youtubeMobileRegex = /(http:|https:)?\/\/(m\.)?(youtube.com|youtu.be)\/(watch)?(\?v=)?(\S+)?/
        const vimeoRegex = /(https?):\/\/(?:www\.)?(?:vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)|player\.vimeo\.com\/video\/(\d+)(?:$|\/|\?))/
        const youtubePlaylistRegex = /(?:http:|https:)?\/\/(?:www\.)?youtube\.com\/watch\?(?:.*?&)?v=([a-zA-Z0-9_\-]{11})(?:&.*)?$/
        const issuuRegex = /https:\/\/issuu\.com\/([^\/]+)\/docs\/([^\/]+)/

        const matchVimeo = videoUrl.match(vimeoRegex)
        const matchIssuu = videoUrl.match(issuuRegex)
        const matchIssuuEmbed = videoUrl.includes('issuu') && videoUrl.includes('embed')
        const matchPlaylist = videoUrl.match(youtubePlaylistRegex)
        const matchYoutube = videoUrl.match(youtubeRegex)
        const matchYoutubeMobile = videoUrl.match(youtubeMobileRegex)

        if (matchPlaylist) {
          const id = matchPlaylist[1]
          item.setAttribute('src', `//youtube.com/embed/${id}${autoplay === 'true' ? '?autoplay=1&mute=1' : ''}`)
        } else if (matchYoutube) {
          const id = matchYoutube[6]
          item.setAttribute('src', `//www.youtube.com/embed/${id}${autoplay === 'true' ? '?autoplay=1&mute=1' : ''}`)
        } else if (matchYoutubeMobile) {
          const id = matchYoutubeMobile[6]
          item.setAttribute('src', `//www.youtube.com/embed/${id}${autoplay === 'true' ? '?autoplay=1&mute=1' : ''}`)
        } else if (matchVimeo) {
          const id = matchVimeo[4] ? matchVimeo[4] : matchVimeo[5]

          // Video ID is from vimeo.com/ (matchVimeo[4]) or player.vimeo.com/ (matchVimeo[5])
          item.setAttribute('src', `//player.vimeo.com/video/${id}${autoplay === 'true' ? '?autoplay=1' : ''}`)
        } else if (matchIssuuEmbed) {
          item.setAttribute('src', videoUrl)
        } else if (matchIssuu) {
          const username = matchIssuu[1]
          const documentName = matchIssuu[2]

          item.setAttribute('src', `//e.issuu.com/embed.html?d=${documentName}&u=${username}`)
        }
      }
    })
  },
}

export default videoOverlay
